<template>
  <el-aside style="width: auto;">
    <el-menu @select="select" style="height:100%;width:auth;" :collapse="isCollapse" class="el-menu-vertical-demo"
      background-color="#282d2f" text-color="#fff" active-text-color="#ffd04b">
      <el-menu-item index="0">
        <i class="el-icon-location"></i>
        <span slot="title">首页</span>
      </el-menu-item>

      <el-menu-item index="1">
        <i class="icon iconfont icon-app pub-icon"></i>
        <span slot="title">应用列表</span>
      </el-menu-item>

      <el-submenu index="2">
        <template slot="title">
          <i class="icon iconfont icon-app1 pub-icon"></i>
          <span slot="title">应用管理</span>
        </template>
        <el-submenu v-for="item in app_list" :index="'2-'+item.id">
          <template slot="title">

            <div style="overflow: hidden;
text-overflow:ellipsis;
white-space:  nowrap;">┗ {{item.title}}</div>
          </template>
          <el-menu-item :index="'2-3-'+item.id"><i class="el-icon-info"></i>版本管理</el-menu-item>
          <el-menu-item :index="'2-10-'+item.id"><i class="el-icon-receiving"></i>远程变量</el-menu-item>
          <el-menu-item :index="'2-1-'+item.id"><i class="el-icon-tickets"></i>卡密列表</el-menu-item>

          <el-menu-item :index="'2-4-'+item.id"><i class="el-icon-coin"></i>卡密价格</el-menu-item>

          <el-menu-item :index="'2-2-'+item.id"><i class="icon iconfont icon-204 pub-icon"></i>授权管理</el-menu-item>

          <el-menu-item :index="'2-5-'+item.id"><i class="el-icon-s-order"></i>授权日志</el-menu-item>

        </el-submenu>

      </el-submenu>
      <el-submenu index="8">
        <template slot="title">
          <i class="el-icon-user-solid"></i>
          <span slot="title">代理系统</span>
        </template>
        <el-menu-item index="2-6"><i class="el-icon-medal"></i>代理等级</el-menu-item>
        <el-menu-item index="2-7"><i class="el-icon-user"></i>代理账号</el-menu-item>
        <el-menu-item index="2-8"><i class="el-icon-s-order"></i>提卡日志</el-menu-item>
        <el-menu-item index="2-9"><i class="el-icon-money"></i>资金流水</el-menu-item>
      </el-submenu>
      <el-submenu index="9">
        <template slot="title">
          <i class="el-icon-s-custom"></i>
          <span slot="title" style="color:#F56C6C;">专业版服务</span>
        </template>
        <el-menu-item index="9-1"><i class="el-icon-shopping-cart-full"></i>开通服务</el-menu-item>
        <el-menu-item index="9-2"><i class="el-icon-present"></i>资源包</el-menu-item>
      </el-submenu>

      <el-menu-item index="3">
        <i class="el-icon-download"></i>
        <span slot="title">下载中心</span>
      </el-menu-item>
      <el-menu-item index="4">
        <i class="el-icon-document"></i>
        <span slot="title">开发文档</span>
      </el-menu-item>
      <el-menu-item index="5">
        <i class="el-icon-refresh"></i>
        <span slot="title">更新日志</span>
      </el-menu-item>
      <el-menu-item index="7">
        <i class="el-icon-mobile-phone"></i>
        <span slot="title">APP&小程序</span>
      </el-menu-item>


      <el-menu-item index="6">
        <i class="el-icon-back"></i>
        <span slot="title">退出</span>
      </el-menu-item>
    </el-menu>
  </el-aside>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    computed: {
      app_list() {
        return this.$store.state.app_list
      },

    },
    props: [
      'isCollapse'
    ],
    created() {
      this.getAppList()
    },

    methods: {
      select(index, indexPath) {

        if (index.substring(0, 4) == 'http') {
          window.open(index)
        } else {
          var arr = index.split("-")
          console.log(arr)
          switch (arr[0]) {
            case "0":
              this.$router.push({
                path: '/'
              })
              break
            case "1":
              this.$router.push({
                path: '/app'
              })
              break
            case "2":
              //应用管理
              switch (arr[1]) {

                case "1":
                  this.$router.push({
                    path: '/cdk',
                    query: {
                      id: arr[2]
                    }
                  })
                  break;
                case "2":
                  this.$router.push({
                    path: '/auth',
                    query: {
                      id: arr[2]
                    }
                  })
                  break;
                case "3":
                  this.$router.push({
                    path: '/version',
                    query: {
                      id: arr[2]
                    }
                  })
                  break;
                case "4":
                  this.$router.push({
                    path: '/cdk_spec',
                    query: {
                      id: arr[2]
                    }
                  })
                  break;
                case "5":
                  this.$router.push({
                    path: '/log/auth',
                    query: {
                      id: arr[2]
                    }
                  })
                  break;
                case "6":
                  this.$router.push({
                    path: '/agent_type',

                  })
                  break;
                case "7":
                  this.$router.push({
                    path: '/agent',

                  })
                  break;
                case "8":
                  this.$router.push({
                    path: '/log/cdk',

                  })
                  break;
                case "9":
                  this.$router.push({
                    path: '/log/amount',

                  })
                  break;
                case "10":
                  this.$router.push({
                    path: '/variable',
                    query: {
                      id: arr[2]
                    }
                  })
                  break;


              }

              break
            case "3":
              this.$router.push({
                path: '/download'
              })
              break
            case "4":
              window.open('https://www.kancloud.cn/lisao/boat/860604')
              break
            case "5":
              this.$router.push({
                path: '/update'
              })
              break
            case "6":
              this.$layer.msg('退出成功')
              this.$cookies.remove('user_token')
              this.$router.push({
                path: '/login'
              })
              break
            case "7":
              this.$router.push({
                path: '/program'
              })
              break
            case "9":
              //应用管理
              switch (arr[1]) {

                case "1":
                  this.$router.push({
                    path: '/vip',
                    query: {
                      id: arr[2]
                    }
                  })
                  break
                case "2":
                  this.$router.push({
                    path: '/vip/package',
                    query: {
                      id: arr[2]
                    }
                  })
                  break
              }
              break


          }
          /*
          this.$router.push({
          	path: index
          })
          */
        }

      },
      /**
       * 获取应用列表
       */
      getAppList() {
        var obj = this
        var loading = obj.$layer.loading(1);
        this.$ajax({
          method: 'get',
          url: global.url + '/developer/app',

        }).then(function(res) {
          obj.$layer.close(loading)
          if (res.data.error === 0) {
            obj.$store.commit('updateAppList', res.data.data.list)
          } else {
            obj.$layer.msg(res.data.msg)
          }

        }).catch(function(res) {
          obj.$layer.close(loading)
          obj.$layer.msg('网络错误')
        })
      }
    }
  }
</script>

<style scoped>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    border: 0px;
    height: 100%;
    text-align: left;
  }

  li.el-menu-item {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Nav.vue